import React, { useEffect, useState } from "react";
import PageHeader from "../../../pageheader/PageHeader";
import MenuAdmin from "../../navAdmin/Menu";
import moment from "moment";

import styles from "./HospitalSetting.module.css";
import Input from "../../../material/input/Input";
import Button from "../../../material/button/Button";

import searchIcon from "../../../../asset/icon/search.svg";
import plusSmall from "../../../../asset/icon/plus-small.svg";
import Pagination from "../../../pagination/Pagination";

import * as adminApi from "../../../../service/adminApi";
import { useNavigate } from "react-router-dom";
import { RedirectCode400 } from "../../../RedirectCode400";
import { TrashIcon } from "@heroicons/react/24/outline";

import { CurrentUserContext } from "../../../../App";
import { useContext } from "react";

import Breadcrumb from "../../../breadcrumb/breadcrumb";

import DataTable from "react-data-table-component";
import PageHeaderV2 from "../../../pageheaderV2/PageHeaderV2";
const customStyles = {
  rows: {
    style: {
      // override the row height
      "&:nth-child(even)": {
        background: "#effff4",
      },
      "&:not(:last-of-type)": {
        borderBottomWidth: "none",
      },
    },
  },
  headCells: {
    style: {
      // override the cell padding for head cells
      display: "flex",
      justifyContent: "center",
      background: "#B8DFC7",
      fontSize: 18,
      "@media (max-width: 800px)": {
        fontSize: 14,
      },
    },
  },
  cells: {
    style: {
      // override the cell padding for data cells
      display: "flex",
      justifyContent: "center",
      borber: "1px solid #B8DFC7",
    },
  },
};

function HospitalSetting() {
  const { setIsMessage } = useContext(CurrentUserContext);

  const navigate = useNavigate();

  const [date, setDate] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const [dataHospital, setDataHospital] = useState([]);
  const [numberHospital, setNumberHospital] = useState("");

  const [showList, setShowList] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);

  const [inputvalue, setInputValue] = useState("");
  const [saveData, setSaveData] = useState([]);

  useEffect(() => {
    setDate(moment().add(543, "years").format("DD MMMM YYYY"));
  }, []);

  useEffect(() => {
    getHospital(page, 10);
  }, []);

  useEffect(() => {
    let start = page * 10 - 10;

    setShowList(dataHospital.slice(start, start + 10));
  }, [page, dataHospital]);

  const getHospital = async () => {
    setIsLoading(true);
    let res = await adminApi.getHospital(page, 10);
    setIsLoading(false);
    if (res) {
      if (res["data"]["code"] === 200) {
        setDataHospital(res["data"]["webhook_list"]);
        setSaveData(res["data"]["webhook_list"]);
        setTotalPage(Math.ceil(res.data?.webhook_list?.length / 10));

        let numberOfHospital = res["data"]["webhook_list"].length;
        setNumberHospital(numberOfHospital);
      } else if (res["data"]["code"] === 403) {
        navigate(RedirectCode400());
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const handleChangeSearch = (value) => {
    setInputValue(value);
  };

  const handleClickSearch = () => {
    // console.log(dataHospital);
    if (inputvalue !== "") {
      const filterData = dataHospital.filter((item) => {
        return item["hospital_name"]
          ?.toLowerCase()
          .includes(inputvalue?.toLowerCase());
      });
      setDataHospital(filterData);
    } else {
      setDataHospital(saveData);
    }
  };

  const onclickAddData = (action, item) => {
    // console.log(action);
    if (action === "add") {
      navigate("/admin/AddHospital");
    } else if (action === "edit") {
      navigate("/admin/AddHospital", {
        state: {
          mode: "edit",
          data: {
            webhook_id: item["webhook_id"],
            hospital_id: item["hospital_id"],
            send: item["send"],
            revoke: item["revoke"],
          },
        },
      });
    }
  };

  const HandleClickRemove = (item) => {
    if (!window.confirm(`คุณต้องการลบ ${item["hospital_name"]} ใช่หรือไม่`)) {
      return;
    }
    removeWebBook(item["webhook_id"]);
  };

  const removeWebBook = async (webhook_id) => {
    let res = await adminApi.removeWebHook(webhook_id);
    if (res) {
      if (res["data"]["code"] === 200) {
        getHospital(page, 10);
      } else if (res["data"]["code"] === 403) {
        navigate(RedirectCode400());
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
      setDataHospital([]);
      setSaveData([]);
    }
  };

  const columns = [
    {
      name: "ลำดับที่",
      selector: (i, idx) => <div>{10 * (page - 1) + 1 + idx}</div>,
      width: "20%",
    },
    {
      name: "ชื่อโรงพยาบาล/ หน่วยงาน",
      selector: (i) => (
        <div
          className="hover:cursor-pointer hover:bg-[#fff8f5]"
          onClick={() => {
            onclickAddData("edit", i);
          }}
        >
          {i["hospital_name"]}
        </div>
      ),
      wrap: true,
    },
    {
      name: "ลบ",
      selector: (i) => (
        <div className="flex justify-center">
          <TrashIcon
            onClick={() => {
              HandleClickRemove(i);
            }}
            className="w-6 stroke-[#E4642A] hover:cursor-pointer"
          />
        </div>
      ),
      width: "20%",
    },
  ];

  const pathItems = [
    { name: "หน้าหลัก", url: "/" },
    { name: "ตั้งค่าโรงพยาบาล", url: "/managewebsite" },
  ];

  return (
    <div className="global-page">
      <Breadcrumb pathItems={pathItems} />
      <PageHeaderV2 titlename={"ตั้งค่าการแลกเปลี่ยนข้อมูลในโรงพยาบาล"} />
      <div className={styles.container}>
        <div className={styles.align} style={{ marginTop: "3%" }}>
          <div className={styles.subTitle}>
            รายชื่อโรงพยาบาลที่แลกเปลี่ยนข้อมูล
          </div>
          <div className={styles.subTitle2}>{`(ข้อมูลวันที่ ${date})`}</div>
        </div>
        <div className={styles.text}>จำนวน {numberHospital} โรงพยาบาล</div>
        <div className={styles.alignData}>
          <div className={styles.alignInput}>
            <div className={styles.size}>
              <Input
                disabledLabel={true}
                placeholder="ค้นหาชื่อโรงพยาบาล"
                value={inputvalue}
                setValue={handleChangeSearch}
              />
            </div>
            <Button onClick={handleClickSearch}>
              <img src={searchIcon} />
              <div style={{ marginLeft: "10px" }}>ค้นหา</div>
            </Button>
          </div>
          <Button
            onClick={() => {
              onclickAddData("add");
            }}
          >
            <img src={plusSmall} />
            <div style={{ marginLeft: "10px" }}>เพิ่มโรงพยาบาล 55555</div>
          </Button>
        </div>
        <div style={{ paddingTop: "3%" }}>
          <DataTable
            className="classTable"
            columns={columns}
            data={showList}
            customStyles={customStyles}
            noDataComponent={<div style={{ margin: "10%" }}>ไม่พบข้อมูล</div>}
          />
          <div>
            <Pagination
              clickForward={() => {
                if (page < totalPage) {
                  setPage(page + 1);
                }
              }}
              clickBackward={() => {
                if (page > 1) {
                  setPage(page - 1);
                }
              }}
              page={page}
              totalpage={totalPage}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
export default HospitalSetting;
